module.exports = __webpack_public_path__ + "static/media/flyingaway.72fea885.mp4";